// The navbar component. Includes everything that shows on the navbar. The navbar shows on every page since it's
// part of the Root element (in App.js) that shows for every single route on the site. The other part of the Root
// element is the Outlet, which shows content for the specific current route.

// IMPORTS FROM MUI, REACT-ROUTER-DOM, REACT
import {
  AppBar,
  Toolbar,
  Typography,
  Stack,
  Button,
  Menu,
  MenuItem,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Link } from "react-router-dom";
import { useState } from "react";

// NAVBAR COMPONENT
export const Navbar = () => {
  // First take care of the "About The Park" button dropdown state and event handlers
  // The anchorElement is the element that the dropdown list opens from. It gets set to the "About The Park" button
  // in handleParkInfoClick
  const [anchorElement, setAnchorElement] = useState(null);
  const dropdownIsOpen = Boolean(anchorElement);
  const handleParkInfoClick = (event) => {
    setAnchorElement(event.currentTarget);
  };
  const handleParkInfoClose = (event) => {
    setAnchorElement(null);
  };

  return (
    <div className="app-navbar">
      {/* 013415 */}
      {/* 025322 is the one in the screenshot that looked good */}
      <AppBar
        sx={{ background: "transparent" }}
        position="static"
        elevation={0}
      >
        {/* What happens when with mobile vs. desktop here? The navbar-text-mobile */}
        <Typography
          align="center"
          variant="h6"
          component="div"
          className="navbar-text-mobile"
        >
          Lands End Park
        </Typography>
        <Typography
          align="center"
          variant="h6"
          component="div"
          className="navbar-text-mobile"
        >
          Tobermory, ON
        </Typography>
        <Toolbar>
          <Typography
            variant="h6"
            component="div"
            className="navbar-text-desktop"
          >
            Lands End Park
          </Typography>
          <Stack
            direction="row"
            spacing={2}
            className="navbar-buttons-container"
          >
            {/* Home button */}

            <Link to="/" className="link">
              <Button className="link" color="secondary">Home</Button>
            </Link>

            {/* Book button */}

            <Link to="/book" className="link">
              <Button className="link" color="secondary">Book</Button>
            </Link>

            {/* About the park button with dropdown list */}
            <Button
              id="parkInfoButton"
              color="inherit"
              onClick={handleParkInfoClick}
              className="link"
              aria-controls={dropdownIsOpen ? "park-info-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={dropdownIsOpen ? "true" : undefined}
              endIcon={<KeyboardArrowDownIcon />}
            >
              About the park
            </Button>
          </Stack>

          {/* dropdown list that opens from the about the park button*/}
          <Menu
            id="parkInfoMenu"
            anchorEl={anchorElement}
            open={dropdownIsOpen}
            MenuListProps={{ "aria-labelledby": "parkInfoButton" }}
            onClose={handleParkInfoClose}
          >
            <Link to="/rates">
              <MenuItem onClick={handleParkInfoClose}> Rates</MenuItem>
            </Link>

            <Link to="/rules">
              <MenuItem onClick={handleParkInfoClose}> Rules</MenuItem>
            </Link>

            <Link to="/sites">
              <MenuItem onClick={handleParkInfoClose}>
                {" "}
                Sites And Cabins
              </MenuItem>
            </Link>

            <Link to="/rentals">
              <MenuItem onClick={handleParkInfoClose}> Rentals</MenuItem>
            </Link>

            <Link to="/park">
              <MenuItem onClick={handleParkInfoClose}>
                {" "}
                What's In Our Park
              </MenuItem>
            </Link>

            <Link to="/area">
              <MenuItem onClick={handleParkInfoClose}>
                {" "}
                What's In The Area
              </MenuItem>
            </Link>

            <Link to="/storeitems">
              <MenuItem onClick={handleParkInfoClose}>
                {" "}
                List Of Store Items
              </MenuItem>
            </Link>

            <Link to="/contact">
              <MenuItem onClick={handleParkInfoClose}> Contact Us</MenuItem>
            </Link>
          </Menu>

          <Stack direction="row" spacing={2}>
            <Typography
              variant="body2"
              component="div"
              sx={{ fontWeight: "bold" }}
              className="navbar-text-desktop"
            >
              Tobermory, ON
            </Typography>
          </Stack>
        </Toolbar>
      </AppBar>
    </div>
  );
};
